<template>
  <div class="animated fadeIn">
    <ValidationObserver v-slot="{ invalid }">
      <b-row>
        <b-col>
          <transition name="fade">
            <b-card
              border-variant="info"
              header-bg-variant="primary"
              header-text-variant="white"
            >
              <div slot="header">
                <span data-font="22" class="mt-2">Create Template</span>
                <div class="card-header-actions">
                  <eb-button
                    class="mr-1 btn-primary"
                    text="Back"
                    @click="$router.push('/notification-template')"
                  >
                  </eb-button>
                </div>
              </div>
              <div>
                <b-row class="form-row">
                  <b-col cols="12" sm="12" md="6" class="mb-3 mb-md-0">
                    <label class="label">Concern</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Concern"
                    >
                      <input
                        disabled
                        type="text"
                        placeholder="Concern"
                        class="form-control w-100"
                        v-model="templateToEdit[0].concern"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="templateToEdit[0].service === 'EMAIL'" class="form-row">
                  <b-col cols="12">
                    <h4 class="pt-2 m-2 section-title">Email Template</h4>
                    <label class="label">Subject</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Subject"
                    >
                      <input
                        type="text"
                        placeholder="Subject"
                        maxlength="100"
                        class="form-control w-100"
                        v-model="templateToEdit[0].subject"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="templateToEdit[0].service === 'EMAIL'" class="form-row">
                  <b-col cols="12">
                    <label class="label">Body</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="HtmlEmailText"
                    >
                      <textarea
                        type="text"
                        rows="4"
                        maxlength="1000"
                        placeholder="HTML (text Area)"
                        class="form-control w-100"
                        v-model="templateToEdit[0].body"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="templateToEdit[0].service === 'EMAIL'" class="form-row">
                  <b-col cols="12">
                    <label class="label">CSS (Optional)</label>
                    <ValidationProvider v-slot="{ errors }" name="CssText">
                      <textarea
                        type="text"
                        rows="4"
                        maxlength="1000"
                        placeholder="CSS (text Area)"
                        class="form-control w-100"
                        v-model="templateToEdit[0].css"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="templateToEdit[0].service === 'EMAIL'" class="form-row">
                  <b-col cols="12" sm="12" md="6" class="mb-3 mb-md-0">
                    <label class="label">From Name</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="From Name"
                    >
                      <input
                        type="text"
                        maxlength="100"
                        placeholder="From Name"
                        class="form-control w-100"
                        v-model="templateToEdit[0].from.name"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                  <b-col cols="12" sm="12" md="6" class="mb-3 mb-md-0">
                    <label class="label">From Email</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="From Email"
                    >
                      <input
                        type="text"
                        maxlength="100"
                        placeholder="From Email"
                        class="form-control w-100"
                        v-model="templateToEdit[0].from.email"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="templateToEdit[0].service === 'SMS'" class="form-row">
                  <b-col cols="12">
                    <h4 class="pt-2 m-2 section-title">SMS Template</h4>
                    <label class="label">Body</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="HtmlSmsText"
                    >
                      <textarea
                        rows="4"
                        type="text"
                        maxlength="1000"
                        placeholder="HTML (text Area)"
                        class="form-control w-100"
                        v-model="templateToEdit[0].body"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="templateToEdit[0].service === 'SMS'" class="form-row">
                  <b-col cols="12">
                    <label class="label">Template Id</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="TemplateId"
                    >
                      <input
                        maxlength="100"
                        type="text"
                        placeholder="Template ID"
                        class="form-control w-100"
                        v-model="templateToEdit[0].templateId"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="templateToEdit[0].service === 'WHATSAPP'" class="form-row">
                  <b-col cols="12" class="pb-2 mt-3">
                    <h4 class="section-title">Whatsapp Template</h4>
                  </b-col>
                  <b-col cols="12" sm="12" md="6" class="pt-0 mb-3 mb-md-0">
                    <label class="label">Header (Optional)</label>
                    <h5 class="header-help-text">
                      Add a title or choose which type of media you'll use for
                      this header.
                    </h5>
                    <eb-select
                      type="text"
                      label="text"
                      placeholder="Select Header"
                      :options="headerOptions"
                      :v-model="selectedHeaderOption"
                      :selected="selectedHeaderOption.text"
                    ></eb-select>
                    <div class="row mt-2">
                      <b-col class="mt-1 mb-2">
                        <b-form-file
                          v-if="selectedHeaderOption.value == 'image'"
                          placeholder="Upload File"
                          drop-placeholder="Drop file here..."
                          v-model="attachment"
                          accept="image/*"
                          :state="Boolean(attachment)"
                          @change="readFile"
                        >
                        </b-form-file>
                        <b-form-file
                          v-if="selectedHeaderOption.value == 'document'"
                          placeholder="Upload File"
                          drop-placeholder="Drop file here..."
                          v-model="attachment"
                          accept="document/*"
                          :state="Boolean(attachment)"
                          @change="readFile"
                        >
                        </b-form-file>
                        <b-form-file
                          v-if="selectedHeaderOption.value == 'video'"
                          placeholder="Upload File"
                          drop-placeholder="Drop file here..."
                          v-model="attachment"
                          accept="video/*"
                          :state="Boolean(attachment)"
                          @change="readFile"
                        >
                        </b-form-file>
                        <b-form-input
                          v-if="selectedHeaderOption.value == 'text'"
                          placeholder="Enter Title"
                          v-model="headerText"
                        >
                        </b-form-input>
                      </b-col>
                    </div>
                  </b-col>
                  <b-col cols="12" sm="12" md="6" class="pt-0 mb-3 mb-md-0">
                    <label class="label">Body</label>
                    <h5 class="header-help-text">
                      Enter the text for your message.
                    </h5>
                    <div
                      class="row"
                      v-for="(bodyTxt, index) in templateToEdit[0].components[1]
                        .parameters"
                      :key="`textBody-${index}`"
                    >
                      <b-col cols="12" sm="8" md="9" class="mb-2 mb-sm-0">
                        <b-form-input
                          :id="`textBody${index}`"
                          type="text"
                          label="text"
                          placeholder="Enter Body Text"
                          v-model="bodyTxt.text"
                        ></b-form-input>
                      </b-col>
                      <b-col cols="6" sm="2" md="1" class="mb-2 mb-sm-0">
                        <b-button
                          @click="
                            addBodyText(
                              bodyTxt,
                              templateToEdit[0].components[1].parameters
                            )
                          "
                          variant="success"
                          class="circularBtn w-100"
                        >
                          <span>
                            <i class="fa fa-plus" aria-hidden="true"></i>
                          </span>
                        </b-button>
                      </b-col>
                      <b-col cols="6" sm="2" md="1" class="mb-2 mb-sm-0">
                        <b-button
                          v-show="
                            templateToEdit[0].components[1].parameters.length >
                            1
                          "
                          @click="
                            removeBodyText(
                              index,
                              templateToEdit[0].components[1].parameters
                            )
                          "
                          variant="danger"
                          class="circularBtn w-100"
                        >
                          <span>
                            <i class="fa fa-minus" aria-hidden="true"></i>
                          </span>
                        </b-button>
                      </b-col>
                    </div>
                  </b-col>
                  <b-col cols="12" sm="12" md="6" class="mb-3 mb-md-0">
                    <label class="label">Template Id</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Whatsapp Template ID"
                    >
                      <input
                        maxlength="100"
                        type="text"
                        placeholder="Enter Template ID"
                        class="form-control w-100"
                        v-model="templateToEdit[0].templateId"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="templateToEdit[0].service === 'INAPP'" class="form-row">
                  <b-col cols="12">
                    <h4 class="pt-2 m-2 section-title">Inapp Template</h4>
                    <label class="label">Subject</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Subject"
                    >
                      <input
                        type="text"
                        maxlength="100"
                        placeholder="Subject"
                        class="form-control w-100"
                        v-model="templateToEdit[0].subject"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <b-row v-if="templateToEdit[0].service === 'INAPP'" class="form-row">
                  <b-col cols="12">
                    <label class="label">Body</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="HtmlInappText"
                    >
                      <textarea
                        rows="4"
                        type="text"
                        maxlength="1000"
                        placeholder="HTML (text Area)"
                        class="form-control w-100"
                        v-model="templateToEdit[0].body"
                        required
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <div class="text-center mt-4">
                  <button
                    type="submit"
                    @click="submitUpdateTemplate"
                    class="btn btn-primary"
                    :disabled="invalid"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </b-card>
          </transition>
        </b-col>
      </b-row>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import cInput from "@/components/Common/CustomInput";
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";
export default {
  name: "CreateTemplate",
  components: {
    ebSelect,
    ebButton,
    ValidationProvider,
    ValidationObserver,
    cInput,
  },

  data() {
    return {
      selectedTemplateOption: "email",
      selectedHeaderOption: "",
      headerOptions: [
        {
          text: "Document",
          value: "document",
        },
        {
          text: "Image",
          value: "image",
        },
        {
          text: "Video",
          value: "video",
        },
        {
          text: "Title",
          value: "text",
        },
      ],
      bodyText: [{ type: "text", text: "" }],
      templateIdWhatsapp: "",
      attachment: "",
      attachmentName: "",
      headerText: "",
    };
  },
  computed: {
    ...mapGetters({
      getEditTemplate: "emailTemplate/GetEditTemplate",
    }),
    templateToEdit() {
      if (
        Array.isArray(this.getEditTemplate) &&
        this.getEditTemplate.length > 0
      ) {
        let templateType = this.getEditTemplate.filter((obj) => {
          return obj._id === this.$route.params.id;
        });
        return templateType;
      }
    },
  },
  methods: {
    async submitUpdateTemplate() {
      let id = "";
      if (this.templateToEdit[0].concern) {
        if (
          this.templateToEdit[0].subject &&
          this.templateToEdit[0].from.name &&
          this.templateToEdit[0].from.email &&
          this.templateToEdit[0].service === "EMAIL"
        ) {
          let payload = {
            id: this.$route.params.id,
            data: {
              subject: this.templateToEdit[0].subject,
              body: this.templateToEdit[0].body,
              css: this.templateToEdit[0].css,
              from: {
                email: this.templateToEdit[0].from.email,
                name: this.templateToEdit[0].from.name,
              },
            },
          };
          await this.$store
            .dispatch("emailTemplate/updateEmailTemplate", payload, id)
            .then((result) => {
              this.$swal({
                title: "Success",
                text: "Email Template Updated Successfully!",
                type: "success",
              });
              this.$router.push("/notification-template");
            })
            .catch((err) => {
              this.$swal({
                title: "Sorry",
                text: "Unable to Update Template",
                type: "error",
              });
            });
        }
        if (
          this.templateToEdit[0].body &&
          this.templateToEdit[0].service === "SMS"
        ) {
          let payload = {
            id: this.$route.params.id,
            data: {
              body: this.templateToEdit[0].body,
            },
          };
          await this.$store
            .dispatch("smsTemplate/updateSmsTemplate", payload)
            .then((result) => {
              this.$swal({
                title: "Success",
                text: "Template Updated Successfully!",
                type: "success",
              });
              this.$router.push("/notification-template");
            })
            .catch((err) => {
              this.$swal({
                title: "Sorry",
                text: "Unable to Update Template",
                type: "error",
              });
            });
        }
        if (
          this.bodyText.text != "" &&
          this.templateToEdit[0].service === "WHATSAPP"
        ) {
          let headerParameter = [];
          let bodyParameter = [];
          if (this.selectedHeaderOption.value == "text") {
            headerParameter.push({
              type: this.selectedHeaderOption.value,
              text: this.headerText,
            });
          } else if (this.selectedHeaderOption.value == "document") {
            headerParameter.push({
              type: this.selectedHeaderOption.value,
              document: {
                link: this.attachment,
                filename: this.attachmentName,
              },
            });
          } else if (this.selectedHeaderOption.value == "image") {
            headerParameter.push({
              type: this.selectedHeaderOption.value,
              image: { link: this.attachment },
            });
          } else if (this.selectedHeaderOption.value == "video") {
            headerParameter.push({
              type: this.selectedHeaderOption.value,
              video: { link: this.attachment },
            });
          }
          this.templateType[0]?.components[1]?.parameters?.map((oneText) =>
            bodyParameter.push({
              type: "text",
              text: oneText.text,
            })
          );
          let payload = {
            concern: this.selectedOption,
            serviceName: "batch",
            whatsapp: {
              templateId: this.templateIdWhatsapp,
              components: [
                {
                  type: "header",
                  parameters: headerParameter,
                },
                {
                  type: "body",
                  parameters: bodyParameter,
                },
              ],
              active: true,
            },
          };
          await this.$store
            .dispatch("whatsappTemplate/createWhatsappTemplate", payload)
            .then((result) => {
              this.$swal({
                title: "Success",
                text: "Template Created Successfully!",
                type: "success",
              });
              this.$router.push("/notification-template");
            })
            .catch((err) => {
              this.$swal({
                title: "Sorry",
                text: "Unable to Create Template",
                type: "error",
              });
            });
        }
        if (
          this.templateToEdit[0].body &&
          this.templateToEdit[0].subject &&
          this.templateToEdit[0].service === "INAPP"
        ) {
          let payload = {
            id: this.$route.params.id,
            data: {
              subject: this.templateToEdit[0].subject,
              body: this.templateToEdit[0].body,
            },
          };
          await this.$store
            .dispatch("inappTemplate/updateInappTemplate", payload)
            .then((result) => {
              this.$swal({
                title: "Success",
                text: "Template Updated Successfully!",
                type: "success",
              });
              this.$router.push("/notification-template");
            })
            .catch((err) => {
              this.$swal({
                title: "Sorry",
                text: "Unable to Update Template",
                type: "error",
              });
            });
        }
      } else {
        this.$swal({
          title: "Error",
          text: "Select All Fields",
          type: "error",
        });
      }
    },
    addBodyText(value, textType) {
      textType.push({ value: "" });
    },
    removeBodyText(index, textType) {
      textType.splice(index, 1);
    },
    readFile(e) {
      if (
        (this.selectedHeaderOption.value == "image" &&
          !e.target.files[0].type.match("image.*")) ||
        (this.selectedHeaderOption.value == "video" &&
          !e.target.files[0].type.match("video.*"))
      ) {
        this.invalid = true;
        this.$toasted.error("Invalid File format");
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      this.attachmentName = e.target.files[0].name;
      reader.onload = () => {
        this.uploadFile(reader.result);
      };
      reader.onerror = (err) => {
        this.$toasted.error("Image not uploaded..please try again!");
      };
    },
    async uploadFile(file) {
      let dataobj = {
        image: file,
        key: (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase(),
        isPublic: true,
        replaceExisting: true,
        basePath: "tenant",
      };
      this.showCustomToast();
      await this.$store
        .dispatch("inventory/uploadImageToStorage", dataobj)
        .then((res) => {
          if (res) {
            this.clearCustomToast();
            this.attachment = res.data.fileUrl;
          }
        })
        .catch((error) => {
          this.clearCustomToast();
          this.$toasted.error("Image not uploaded..please try again!");
          this.loading = false;
        });
    },
    showCustomToast() {
      Vue.toasted.show("Uploading...", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 1000000,
      });
    },
    clearCustomToast() {
      Vue.toasted.clear();
    },
  },

  async mounted() {
    this.loading = true;
    if (this.$route.params && this.$route.params.id) {
      await this.$store.dispatch(
        "emailTemplate/editTemplate",
        this.$route.params.id
      );
    } else if (!this.$route.params || !this.$route.params.id) {
      this.$router.push("/emailTemplate/fetchTemplateAction");
    }
    this.loading = false;
  },
};
</script>
<style scoped>
.label {
    background-color: #ffff;
    padding: 8px;
    font-family: "Lato";
    font-weight: bold;
}

.form-control {
    height: calc(2.2125rem + 8px);
}

.circularBtn {
    height: 40px;
    width: 40px;
    border-radius: 100%;
    text-align: center;
    min-width: 40px;
}

.form-row {
    margin-bottom: 1rem;
}

.section-title {
    margin-bottom: 0.5rem;
}

.header-help-text {
    margin-top: 0px;
    font-size: 0.875rem;
    color: #6c757d;
}

.validate-error {
    display: block;
    color: red;
    font-size: 12px;
    margin-top: 5px;
}

@media (max-width: 767.98px) {
    .section-title {
        font-size: 1.25rem;
    }

    .circularBtn {
        width: 100%;
        height: 38px;
    }
}
</style>
